import React, { useEffect, useRef, useState } from "react";
import ForexTradeHistoryDataTable from "./ForexTradeHistory";
import ForexOrdersHistoryDataTable from "./ForexOrderHistory";
import { ChevronDownIcon, FilterIcon } from "lucide-react";

// import io from "socket.io-client";

export default function ShowForexHistoryData({
  userId,
  forexTradesHistoryData,
  forexOrdersHistoryData,
  eqityTradeHistory,
  equityOrderHistory,
  currentPage,
  setCurrentPage,
  currentPageOrder,
  setCurrentPageOrder,
  allUser,
  ...props
}) {
  const [currentTab, setCurrentTab] = useState("trades-history");

  const [filterDropDownHistory, setFilterDropDownHistory] = useState(false);
  const [filterByDaysHistory, setFilterByDaysHistory] = useState(false);

  const [userTradeHistoryFno, setUserTradeHistoryFno] = useState([]);
  const [userTradeHistoryEquity, setUserTradeHistoryEquity] = useState([]);
  const [userOrderHistoryFno, setUserOrderHistoryFno] = useState([]);
  const [userOrderHistoryEquity, setUserOrderHistoryEquity] = useState([]);

  const [filteredTradeHistoryFno, setFilteredTradeHistoryFno] =
    useState(userTradeHistoryFno);
  const [filteredTradeHistoryEquity, setFilteredTradeHistoryEquity] = useState(
    userTradeHistoryEquity
  );
  const [filteredOrderHistoryFno, setFilteredOrderHistoryFno] =
    useState(userOrderHistoryFno);
  const [filteredOrderHistoryEquity, setFilteredOrderHistoryEquity] = useState(
    userOrderHistoryEquity
  );
  const [sortOrder, setSortOrder] = useState("asc");
  const [show, setShow] = useState(false);

  const filterByDaysHistoryRef = useRef(null);
  const filterDropDownHistoryRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        filterByDaysHistoryRef.current &&
        !filterByDaysHistoryRef.current.contains(event.target) &&
        filterByDaysHistory
      ) {
        closeFilterByDaysModal();
      }

      if (
        filterDropDownHistoryRef.current &&
        !filterDropDownHistoryRef.current.contains(event.target) &&
        filterDropDownHistory
      ) {
        closeFilterDroprDownModal();
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [filterByDaysHistory, filterDropDownHistory]);

  const showFilterDroprDownModal = () => {
    setFilterDropDownHistory(true);
  };

  const showFilterByDaysModal = () => {
    setFilterByDaysHistory(true);
  };

  const closeFilterDroprDownModal = () => {
    setFilterDropDownHistory(false);
  };

  const closeFilterByDaysModal = () => {
    setFilterByDaysHistory(false);
  };

  const handleChangeTabs = (tabName) => {
    setCurrentTab(tabName);
  };

  useEffect(() => {
    const loadInitialData = () => {
      const tradeHistoryFNO = forexTradesHistoryData.reduce(
        (uniqueClientIdArray, currentItem) => {
          const {
            symbol,
            side,
            tradedqty,
            tradeprice,
            strategy,
            orderdatetime,
            clientid,
          } = currentItem;

          // Check if an object with the same properties already exists in the uniqueClientIdArray
          const existingItemIndex = uniqueClientIdArray.findIndex(
            (item) =>
              item.symbol === symbol &&
              item.side === side &&
              item.tradedqty === tradedqty &&
              item.tradeprice === tradeprice
          );

          // If no matching object is found, add a new object with clientId to the uniqueClientIdArray
          if (existingItemIndex === -1) {
            uniqueClientIdArray.push({
              symbol,
              side,
              tradedqty,
              tradeprice,
              orderdatetime,
              strategy,
              clientIds: [clientid],
            });
          } else {
            // If a matching object is found, add the clientId to the matching item's clientIds array
            uniqueClientIdArray[existingItemIndex].clientIds.push(clientid);
          }

          return uniqueClientIdArray;
        },
        []
      );

      setUserTradeHistoryFno(tradeHistoryFNO);
      setFilteredTradeHistoryFno(tradeHistoryFNO);

      const tradeHistoryEquity = eqityTradeHistory.reduce(
        (uniqueClientIdArray, currentItem) => {
          const {
            symbol,
            side,
            tradedqty,
            strategy,
            tradeprice,
            orderdatetime,
            clientid,
          } = currentItem;

          // Check if an object with the same properties already exists in the uniqueClientIdArray
          const existingItemIndex = uniqueClientIdArray.findIndex(
            (item) =>
              item.symbol === symbol &&
              item.side === side &&
              item.tradedqty === tradedqty &&
              item.tradeprice === tradeprice
          );

          // If no matching object is found, add a new object with clientId to the uniqueClientIdArray
          if (existingItemIndex === -1) {
            uniqueClientIdArray.push({
              symbol,
              side,
              tradedqty,
              tradeprice,
              orderdatetime,
              strategy,
              clientIds: [clientid],
            });
          } else {
            // If a matching object is found, add the clientId to the matching item's clientIds array
            uniqueClientIdArray[existingItemIndex].clientIds.push(clientid);
          }

          return uniqueClientIdArray;
        },
        []
      );

      setUserTradeHistoryEquity(tradeHistoryEquity);
      setFilteredTradeHistoryEquity(tradeHistoryEquity);

      const orderHistoryFNO = forexOrdersHistoryData.reduce(
        (uniqueClientIdArray, currentItem) => {
          const {
            symbol,
            side,
            qty,
            remainingquantity,
            limitprice,
            orderdatetime,
            stopprice,
            strategy,
            status,
            clientid,
          } = currentItem;

          // Check if an object with the same properties already exists in the uniqueClientIdArray
          const existingItemIndex = uniqueClientIdArray.findIndex(
            (item) =>
              item.symbol === symbol &&
              item.side === side &&
              item.remainingquantity === remainingquantity &&
              item.limitprice === limitprice &&
              item.stopprice === stopprice &&
              item.status === status
          );

          // If no matching object is found, add a new object with clientId to the uniqueClientIdArray
          if (existingItemIndex === -1) {
            uniqueClientIdArray.push({
              symbol,
              side,
              qty,
              remainingquantity,
              limitprice,
              orderdatetime,
              stopprice,
              strategy,
              status,
              clientIds: [clientid],
            });
          } else {
            // If a matching object is found, add the clientId to the matching item's clientIds array
            uniqueClientIdArray[existingItemIndex].clientIds.push(clientid);
          }

          return uniqueClientIdArray;
        },
        []
      );
      setUserOrderHistoryFno(orderHistoryFNO);
      setFilteredOrderHistoryFno(orderHistoryFNO);

      const orderHistoryEquity = equityOrderHistory.reduce(
        (uniqueClientIdArray, currentItem) => {
          const {
            symbol,
            side,
            qty,
            remainingquantity,
            limitprice,
            orderdatetime,
            stopprice,
            strategy,
            status,
            clientid,
          } = currentItem;

          // Check if an object with the same properties already exists in the uniqueClientIdArray
          const existingItemIndex = uniqueClientIdArray.findIndex(
            (item) =>
              item.symbol === symbol &&
              item.side === side &&
              item.remainingquantity === remainingquantity &&
              item.limitprice === limitprice &&
              item.stopprice === stopprice &&
              item.status === status
          );

          // If no matching object is found, add a new object with clientId to the uniqueClientIdArray
          if (existingItemIndex === -1) {
            uniqueClientIdArray.push({
              symbol,
              side,
              qty,
              remainingquantity,
              limitprice,
              orderdatetime,
              stopprice,
              strategy,
              status,
              clientIds: [clientid],
            });
          } else {
            // If a matching object is found, add the clientId to the matching item's clientIds array
            uniqueClientIdArray[existingItemIndex].clientIds.push(clientid);
          }

          return uniqueClientIdArray;
        },
        []
      );

      setUserOrderHistoryEquity(orderHistoryEquity);
      setFilteredOrderHistoryEquity(orderHistoryEquity);
    };

    loadInitialData();
  }, [forexTradesHistoryData]);


  // console.log("order history",filteredOrderHistoryFno)
  return (
    <div className="z-0 relative w-full h-full  overflow-hidden  bg-black">
      <div className="flex justify-between bg-[#0F0F0F] h-[60px] px-6 w-full">
        <div className="flex space-x-6">
          <div
            onClick={() => handleChangeTabs("trades-history")}
            className={` ${
              currentTab === "trades-history"
                ? "text-[#07F2C7]  border-[#07F2C7]"
                : "border-transparent"
            } flex items-center border-b-[4px] text-[16px] font-semibold text-gray-400  cursor-pointer transition  duration-300 ease-in `}
          >
            Trades History
          </div>
          <div
            onClick={() => handleChangeTabs("orders-history")}
            className={` ${
              currentTab === "orders-history"
                ? "text-[#07F2C7]  border-[#07F2C7]"
                : "border-transparent"
            } flex items-center border-b-[4px] text-[16px] font-semibold text-gray-400  cursor-pointer transition  duration-300 ease-in `}
          >
            Orders History
          </div>
        </div>

        <div className="relative flex space-x-4 items-center ">
          <button
            onClick={() => setShow(true)}
            className="flex items-center space-x-2 bg-gray-800/40 px-6 py-2.5 rounded-md"
          >
            <span className="text-white text-base uppercase">
              {props.state}
            </span>
            <ChevronDownIcon className="h-5 w-5 text-white" />
          </button>

          {show === true && (
            <div className="z-10 absolute top-16 -left-3 bg-gray-800 w-[160px]  p-1 rounded-sm">
              <div className="flex  flex-col space-y-1 h-full p-2">
                <div
                  className="text-white text-base cursor-pointer hover:bg-gray-900 px-2 py-1 rounded-md "
                  onClick={() => {
                    props.setState("fno");
                    setShow(false);
                  }}
                >
                  FNO
                </div>
                <div
                  className="text-white text-base cursor-pointer hover:bg-gray-900 px-2 py-1 rounded-md "
                  onClick={() => {
                    props.setState("equity");
                    setShow(false);
                  }}
                >
                  EQUITY
                </div>
              </div>
            </div>
          )}

          <button
            ref={filterDropDownHistoryRef}
            onClick={showFilterDroprDownModal}
            className="flex items-center space-x-2 bg-gray-800/40 px-6 py-2.5 rounded-md"
          >
            <FilterIcon className="h-5 w-5 text-white" />
            <span className="text-white text-base">Filter</span>
          </button>

          {filterDropDownHistory && (
            <div
              ref={filterDropDownHistoryRef}
              className="absolute top-16 right-0 bg-gray-800 w-[160px]  p-1 rounded-sm"
            >
              <div className="flex  flex-col space-y-1 h-full p-2">
                <div
                  // onClick={handleAllData}
                  className="text-white text-base cursor-pointer hover:bg-gray-900 px-2 py-1 rounded-md "
                >
                  All
                </div>
                <div
                  // onClick={handleFilterByBuyOrders}
                  className="text-white text-base cursor-pointer hover:bg-gray-900 px-2 py-1 rounded-md"
                >
                  Buy Orders
                </div>
                <div
                  // onClick={handleFilterBySellOrders}
                  className="text-white text-base cursor-pointer hover:bg-gray-900 px-2 py-1 rounded-md"
                >
                  Sell Orders
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {currentTab === "trades-history" && (
        <ForexTradeHistoryDataTable
          forexTradesHistoryData={
            props.state === "equity"
              ? userTradeHistoryEquity
              : userTradeHistoryFno
          }
          filteredTradesHistoryData={
            props.state === "equity"
              ? filteredTradeHistoryEquity
              : filteredTradeHistoryFno
          }
          setFilteredTradeHistoryFno={setFilteredTradeHistoryFno}
          setFilteredTradeHistoryEquity={setFilteredTradeHistoryEquity}
          sortOrder={sortOrder}
          setSortOrder={setSortOrder}
          currentState={props.state}
          currentPage={
            props.state === "equity"
              ? props.currentPageTradeEquity
              : currentPage
          }
          setCurrentPage={
            props.state === "equity"
              ? props.setCurrentPageTradeEquity
              : setCurrentPage
          }
          allUser={allUser && allUser}
        />
      )}
      {currentTab === "orders-history" && (
        <ForexOrdersHistoryDataTable
          forexOrdersHistoryData={
            props.state === "equity"
              ? userOrderHistoryEquity
              : userOrderHistoryFno
          }
          filteredOrdersHistoryData={
            props.state === "equity"
              ? filteredOrderHistoryEquity
              : filteredOrderHistoryFno
          }
          setFilteredOrderHistoryFno={setFilteredOrderHistoryFno}
          setFilteredOrderHistoryEquity={setFilteredOrderHistoryEquity}
          sortOrder={sortOrder}
          setSortOrder={setSortOrder}
          currentState={props.state}
          currentPage={
            props.state === "equity"
              ? props.currentPageOrderEquity
              : currentPageOrder
          }
          setCurrentPage={
            props.state === "equity"
              ? props.setCurrentPageOrderEquity
              : setCurrentPageOrder
          }
          allUser={allUser && allUser}
        />
      )}
    </div>
  );
}
